import HelloUserResumeController from './HelloUserResumeController';
import HelloUserController from './HelloUserController';

export default function registerHelloUserControllers(assessmentFrontendControllers) {
    assessmentFrontendControllers.controller('HelloUserController', ['$scope', '$location', '$routeParams', 'UserInfoService', 'TaskFlowService', 'TaskInfoService', '$bridges', 'Candidate', '$translate', '$rootScope', 'PWAService', '$uibModal', HelloUserController]);
    assessmentFrontendControllers.controller('HelloUserResumeController', ['$scope', '$http', '$timeout', HelloUserResumeController]);
}